<template>
  <div class="txn-wrap">
    <div id="blockNum" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  name: 'BlockNum',
  data() {
    return {
      chart: null,
      intervalId: null,
      option: {
        grid: {
          left: '1%',
          right: '12%',
          bottom: '0%',
          top: '8%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          name: '时间/天', // 在 x 轴末尾添加描述
          nameLocation: 'end', // 指定描述位置为末尾
          nameTextStyle: { color: '#fff' },
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisLabel: {
            fontSize: 12,
            rotate: 35,
            interval: 0,
            textStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            // 去掉刻度
            show: false
          },
          axisLine: {
            // 修改轴线颜色
            lineStyle: {
              color: '#306269'
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#306269',
              width: 0.4
            }
          },
          axisLabel: {
            fontSize: 12,
            textStyle: {
              color: '#fff' // 修改 y 坐标轴标签的字体颜色为红色
            }
          }
        },
        series: [
          {
            // data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            stack: 'total',
            showBackground: true
            // itemStyle: {
            //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            //         offset: 0, color: '#00CBFF'
            //     }, {
            //         offset: 1, color: '#131D21'
            //     }])
            // }
          }
        ]
      }
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },
  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    initChart() {
      let container = document.getElementById('blockNum')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    getData() {
      let cid = this.$store.state.home.chainCid
      let params = {
        chain_id: cid,
        data_type: 3,
        query_range: 0,
        query_step: '',
        query_time: Math.floor(Date.now() / 1000)
      }
      this.$apis.home.getMultiple(params).then(res => {
        if (res.data) {
          const yTimeArray = res.data.time_axis.map((item, index) => {
            return this.timestampToTime(item)
          })

          var seriesArray = []

          res.data.multiple_data.map((item, index) => {
            var obj = {}
            obj.data = item.nums
            obj.name = item.instance

            obj.type = 'bar'
            obj.barWidth = 14
            obj.showBackground = true
            obj.backgroundStyle = {
              // 背景样式配置
              color: '#0A2936'
            }
            obj.barGap = '-100%'
            if (index == 0) {
              obj.itemStyle = {
                // color:'#00CBFF'
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00CBFF'
                  },
                  {
                    offset: 1,
                    color: '#131D21'
                  }
                ])
              }
            } else if (index == 1) {
              obj.itemStyle = {
                // color:'#FFCC00'

                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#FFCC00'
                  },
                  {
                    offset: 1,
                    color: '#131D21'
                  }
                ])
              }
            } else if (index == 2) {
              obj.itemStyle = {
                // color:'#e6762c'

                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#e6762c'
                  },
                  {
                    offset: 1,
                    color: '#131D21'
                  }
                ])
              }
            } else if (index == 3) {
              obj.itemStyle = {
                // color:'#27dfed'
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#27dfed'
                  },
                  {
                    offset: 1,
                    color: '#131D21'
                  }
                ])
              }
            } else if (index == 4) {
              obj.itemStyle = {
                // color:'#fd3838'

                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#fd3838'
                  },
                  {
                    offset: 1,
                    color: '#131D21'
                  }
                ])
              }
            }
            seriesArray.push(obj)
          })

          this.chart.setOption({
            xAxis: {
              data: yTimeArray
            },
            series: seriesArray
          })
        }
      })
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp * 1000) // Fri Aug 26 2022 01:09:43 GMT+0800 (中国标准时间)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return M + D
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.real-wrap,
.line-chart {
  @include px2vw(width, 405);
  @include px2vw(height, 220);
}
</style>
